'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import ContentViewContainer from 'page-editor-ui/containers/views/ContentViewContainer';
import PageSettingsContainerWrapper from 'page-editor-ui/containers/PageSettingsContainerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isPatagonia: getIsUngatedForPatagonia(state)
});
class SettingsContainer extends Component {
  render() {
    const {
      isPatagonia
    } = this.props;
    return isPatagonia ? /*#__PURE__*/_jsx(ContentViewContainer, {}) : /*#__PURE__*/_jsx(PageSettingsContainerWrapper, {});
  }
}
SettingsContainer.propTypes = {
  isPatagonia: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(SettingsContainer);